import React from 'react';
import { FormatNumberOptions } from 'react-intl';

import { useFormatNumber } from '../hooks/useFormatNumber/useFormatNumber';

export function withFormatNumber<T>(
  WrappedComponent: React.ComponentType<T & FormatNumberOptions>,
) {
  return function ComponentWithFormatNumber(props: T & FormatNumberOptions) {
    const formatNumber = useFormatNumber();

    return <WrappedComponent {...props} formatNumber={formatNumber} />;
  };
}
